<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toctitle"><span class="bold">Contents</span></p>
<p class="tocf"><a href="#/04_Foreword"><em class="italic">Foreword by Matthias Strohn</em></a></p>
<p class="tocf"><a href="#/05_Introduction"><em class="italic">Introduction</em></a></p>
<p class="toc1"><a href="#/06_Chapter01">1<span class="spacec">The first day (6 June 1944)</span></a></p>
<p class="toc"><span href="#/07_Chapter02" title="Link target outside of Sample">2<span class="spacec">The battle of Cherbourg (7–26 June 1944)</span></span></p>
<p class="toc"><span href="#/08_Chapter03" title="Link target outside of Sample">3<span class="spacec">The breakthrough of the Americans (26 June–31 July 1944)</span></span></p>
<p class="toc"><span href="#/09_Chapter04" title="Link target outside of Sample">4<span class="spacec">The Falaise pocket</span></span></p>
<p class="toc"><span href="#/10_Chapter05" title="Link target outside of Sample">5<span class="spacec">The last days in Normandy (18–21 August 1944)</span></span></p>
<p class="toc"><span href="#/11_Chapter06" title="Link target outside of Sample">6<span class="spacec">General observations</span></span></p>
<p class="toc"><span href="#/12_Chapter07" title="Link target outside of Sample">7<span class="spacec">The daily activities of military intelligence</span></span></p>
<p class="toca"><span href="#/13_Formations" title="Link target outside of Sample">Formations mentioned in the text</span></p>
<p class="tocf1"><span href="#/14_References" title="Link target outside of Sample"><em class="italic">References</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?943f5332